export default __webpack_public_path__ + "static/overseaspolymer-ae6846e517945cf02de8553e0c1abf4b.png";